import { tooltipClasses } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const Saves = () => {
  const { favouriteOffers } = useSelector((state) => state?.merchantReducer);
  const [chartData, setChartData] = useState({
    categories: [],
    series: [{ name: "Number of Saves", data: [] }],
    fullCategories: [],
  });
  const [maxDataValue, setMaxDataValue] = useState(10);
  const [step, setStep] = useState(2);

  useEffect(() => {
    if (favouriteOffers?.data?.length) {
      const categories = favouriteOffers.data.map((offer) =>
        offer.title.length > 10
          ? offer.title?.slice(0, 10) + "..."
          : offer.title
      );
      const fullCategories = favouriteOffers.data.map((offer) => offer.title);
      const data = favouriteOffers.data.map((offer) => offer.count);

      const calculatedMaxDataValue = Math.max(...data, 5);
      const calculatedStep = Math.ceil(calculatedMaxDataValue / 5);

      setMaxDataValue(calculatedMaxDataValue);
      setStep(calculatedStep);
      setChartData({
        categories,
        fullCategories,
        series: [{ name: "Number of Saves", data }],
      });
    } else {
      // If no data, reset chart with empty series
      setChartData({
        categories: [],
        series: [{ name: "Number of Saves", data: [] }],
        fullCategories: [],
      });
    }
  }, [favouriteOffers]);

  const getTooltipTitle = (dataPointIndex) => {
    return chartData.fullCategories[dataPointIndex] || "";
  };

  const chartOptions = {
    colors: ["#00ADEF", "#80CAEE"],
    chart: {
      fontFamily: "Poppins, sans-serif",
      type: "bar",
      height: 335,
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        columnWidth: "40px",
      },
    },
    dataLabels: { enabled: false },
    legend: {
      position: "top",
      horizontalAlign: "left",
      fontFamily: "Poppins",
      fontWeight: 500,
      fontSize: "14px",
      markers: { radius: 99 },
    },
    fill: { opacity: 1 },
    xaxis: {
      categories: chartData.categories,
      labels: {
        rotate: 0,
        trim: true,
        hideOverlappingLabels: false,
        style: { fontSize: "12px", whiteSpace: "nowrap" },
      },
      title: {
        text: "Offers",
        offsetX: 0,
        style: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#373d3f",
          fontFamily: "Poppins, sans-serif",
        },
      },
    },
    yaxis: {
      min: 0,
      max: Math.ceil(maxDataValue / step) * step,
      tickAmount: Math.ceil(maxDataValue / step),
      labels: {
        formatter: (value) => value,
      },
      title: {
        text: "No. of Favourite Offers",
        style: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#373d3f",
          fontFamily: "Poppins, sans-serif",
          zIndex: 1000,
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      followCursor: true,
      intersect: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const fullTitle = getTooltipTitle(dataPointIndex);
        const value = series[seriesIndex][dataPointIndex];

        return `
          <div class="apexcharts-tooltip-box" style="padding: 8px;">
            <div style="margin-bottom: 5px; font-weight: 600;">${fullTitle}</div>
            <div>Number of Saves: ${value}</div>
          </div>
        `;
      },
    },
  };

  return (
    <div className="w-full rounded-sm border border-stroke bg-white px-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 summary offersChart">
      <div className="flex flex-col sm:flex-col xl:flex-row justify-between w-full my-4">
        <span className="text-[20px] font-poppins font-[600] text-[black] whitespace-nowrap">
          Favourite Offers
        </span>
      </div>

      {chartData.series[0].data.length > 0 ? (
        <div className="w-full overflow-x-auto flex items-center justify-start">
          <div id="chartTwo" className={`${chartData.series[0].data.length > 7 ? "min-w-[45rem] w-full": "min-w-[30rem] w-full"} `}>
            <ReactApexChart
              options={chartOptions}
              series={chartData.series}
              type="bar"
              height={350}
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-[200px] flex items-center justify-center">
          <div id="chartTwo" className="min-w-[700px] w-full">
            <div className="text-center text-gray-500 text-lg font-medium py-10">
              No Favourite Offers Found
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Saves;
